import React from 'react'
import './Specifications.css'

interface Spec {
  specification: string
  standardRange: string
  customOptions: string
}

const specs: Spec[] = [
  {
    specification: 'Material Thickness',
    standardRange: '0.010" - 0.250"',
    customOptions: 'Up to 0.500"'
  },
  {
    specification: 'Material Width',
    standardRange: '12" - 72"',
    customOptions: 'Up to 120"'
  },
  {
    specification: 'Forming Speed',
    standardRange: '50 - 400 FPM',
    customOptions: 'Up to 800 FPM'
  },
  {
    specification: 'Tolerance',
    standardRange: '±0.003"',
    customOptions: '±0.001" available'
  },
  {
    specification: 'Material Types',
    standardRange: 'Steel, Aluminum, Stainless',
    customOptions: 'Exotic alloys, Coated materials'
  }
]

const Specifications: React.FC = () => {
  return (
    <section className="specifications" id="capabilities">
      <div className="container">
        <h2>Technical Capabilities</h2>
        
        <div className="specs-table-wrapper">
          <table className="specs-table">
            <thead>
              <tr>
                <th>Specification</th>
                <th>Standard Range</th>
                <th>Custom Options</th>
              </tr>
            </thead>
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index}>
                  <td>{spec.specification}</td>
                  <td>{spec.standardRange}</td>
                  <td>{spec.customOptions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default Specifications